<div class="confirm-request-wrapper displayFlexColumn">
  <!-- -----------docs -->

  <div class="booking-list">
    <!-- <app-booking-details *ngFor="let booking of request.spotBookings" [booking]="booking"></app-booking-details> -->
    <div class="requestor displayFlexRow">
      <span class="font-weight-700 color-181F33 ">Requester Details</span>
      <div class="requesterdata" *ngIf="request">
        <span class="border">{{request.requester?.name||'--'}} ({{request.requester?.emplId}})</span>
        <span class=" border text-light">{{request.requester?.email|| '--'}}</span>
        <span class="text-light">{{(request.requester?.mobile | formatPhoneNumber : request.requester)|| '--'}}</span>
      </div>
    </div>
    <div *ngIf="uploadedDocumentList.length>0" class="mb-36 mt-16">
      <div class="mb-16 font-weight-400 fs-20 color-000">Uploaded Documents</div>
      <div class="displayFlexRow mb-16">
       <div *ngFor="let image of uploadedDocumentList; let i = index" >
          <div class="doc-items displayFlexSpaceBetween" [ngStyle]="i==uploadedDocumentList.length-1 ?  {'margin-right':'0'} :{'margin-right':'16px'}">
            <div class="displayContents" >
              <div class=" displayContents">
               <img src="assets/documentIcon.svg" alt="">
              </div>
              <div class="file-details">
               <span matTooltip="{{image.filename}}" matTooltipClass="doc-upload-tooltip" class="">{{image.filename}}</span>
               <span class="">{{image.filesize}} MB</span>
              </div>
            </div>
          </div>
       </div>
      </div>
    </div>
    <app-confirm-booking-details *ngFor="let booking of request?.spotBookings" [booking]="booking" [escortConfig]="escortConfig"
    [requester]="request.requester" [bookingsList]="request?.spotBookings"  [miscellConfig]="miscellConfig" [configComplete]="configComplete"></app-confirm-booking-details>
  </div>
  

   <!-- -----------docs -->


  <div>
    <!-- <app-requester-details [requester]="request.requester" [paymentType]="request.requester.paymentType" [booking]="request.spotBookings"></app-requester-details> -->

  </div>
</div>

<!-- <app-popover 
  *ngIf="showPoup"
  size="medium"
  titleText="Manager Approval"
  (closeCallback)="cancelCallback()"
>
  <div popover-content>
    <div class="mb-20">Please select an approver</div>
    <div  *ngFor="let option of approvalManagersList" 
      class="ml-20 mb-20"
    >
      <app-radio-button
        class="option-radio"
        [option]="option"
        [selectedValue]="selectedValue"
        name="manager"
        (changeCallback)="onManagerChange($event)">
      </app-radio-button>
    </div>
    <div *ngIf="showError" class="error-msg">Please select a manager</div>
  </div>
  <div popover-actions>
    <app-button class="mr-10" (clickCallback)="cancelCallback()" type="plainText" text="Cancel"></app-button>
    <app-button type="primaryFilled" text="Select" (clickCallback)="onSubmitClick()"></app-button>
  </div>
</app-popover> -->

<app-dialog
  *ngIf="showDialog"
  titleText="Warning"
  type="confirm"
  [buttonText]="['Yes', 'No']"
  (approveCallback)="makeButtonSubmitEnable()"
  (dismissCallback)="cancelCallback()"
  (closeCallback)="showDialog=false"
  icon="true"
  src="assets/ic-ui-warning-24.svg"
>
This booking will be sent for approval to your manager. Please connect with them for expedited approval.
</app-dialog>

<app-dialog
  *ngIf="showErrorMessage"
  titleText="Error"
  type="confirm"
  [buttonText]="['OK']"
  (approveCallback)="gobackToBookingView()"
  (closeCallback)="showErrorMessage=false"
>
  This booking cannot be created. Approver for this booking is missing.
</app-dialog>

<app-dialog
  *ngIf="customManagerPopups && showCustomManagerConfig "
  titleText="Choose Approving Manager"
  type="confirm"
  [buttonText]="['Submit', 'Clear']"
  (approveCallback)="submitManager()"
  (dismissCallback)="clearManager()"
  (closeCallback)="closeDialog()"
  [src]="'assets/images/cancel_24.svg'"
  [icon]="false"
  [dialogClass]="'managerDialog'"
>
<div class="select-input-container">
  <input type="text" 
  [ngClass]="isTyping  ? 'select-input2' :showManagerError? 'select-input-error':  'select-input'" 
  placeholder="Search"
  onkeypress=" return ((event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 65 && event.charCode <=90) || ((event.charCode >= 48 && event.charCode <= 57)) || (event.charCode==32))"
  #search 
  (keyup)="getManager(search.value)"
  >
</div>
<span class="managerError" *ngIf="showManagerError">
  This field is mandatory 
 </span>
<ul class="select-list" *ngIf="showList && empList.length ">
  <li class="select-option ellipsis" *ngFor="let item of empList" (click)="selectedEmp(item)">
    {{item.employeeName}}
  </li>
</ul>
<div class="msgBox">
  <div *ngIf="selectedManager" class="selectedManager">
    Your Approval Manager is <span class="managerName">{{selectedName}} </span>
  </div>
  <div class="selectManagerMsg">
    To change approval manager, you can search for preferred approval manager.
  </div>
</div>
</app-dialog>
